'use client';

import { c as _c } from "react/compiler-runtime";
import { BuyItAgainCarousel, useQueryBuyItAgain } from '../../../../components/buy-it-again-carousel';
type CarouselContentProps = {
  readonly header: string;
  readonly subheader?: string;
};
export function CarouselContent(t0) {
  const $ = _c(5);
  const {
    header,
    subheader
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      input: {
        placement: "homepage",
        minCount: 2,
        maxCount: 6,
        inventoryList: [],
        excludes: [],
        saleIndicator: true
      }
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    data: products
  } = useQueryBuyItAgain(t1);
  let t2;
  if ($[1] !== header || $[2] !== products || $[3] !== subheader) {
    t2 = <BuyItAgainCarousel header={header} subheader={subheader} minCount={2} products={products} />;
    $[1] = header;
    $[2] = products;
    $[3] = subheader;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}